import { render, staticRenderFns } from "./RestrictArea.vue?vue&type=template&id=c51246da"
import script from "./RestrictArea.vue?vue&type=script&lang=js"
export * from "./RestrictArea.vue?vue&type=script&lang=js"
import style0 from "./RestrictArea.vue?vue&type=style&index=0&id=c51246da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports